import React, { useEffect, useState, useRef } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import '../styles/Chat.scss'
import ChatUserImage from '../assets/imgs/chat-user-image.png'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import AttachmentIcon from '../assets/imgs/attachment-gradient-icon.svg'
import SendIcon from '../assets/imgs/profile-screen-images/send-icon.svg'
import UserPlaceholderImage from '../assets/imgs/user-image-placeholder.png'
import { Avatar, InputAdornment, OutlinedInput, TextField } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import BookingRequestsModal from '../modals/BookingRequestsModal'
import FreshdeskWidget from '@personare/react-freshdesk-widget'
import { getDataById, saveOrUpdateDataById } from '../apis/generalApis'
import moment from 'moment'
import { ScaleLoader } from 'react-spinners'

const Chat = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [isLoading, setIsLoading] = useState(false)
  const hasWindow = typeof window !== 'undefined'
  const location = useLocation()
  const [toggleBookingRequestsModal, setToggleBookingRequestsModal] = useState(
    false,
  )
  const [isResponsive, setIsResponsive] = useState(false)
  const [selectedChat, setSelectedChat] = useState(null)
  const getWindowDimensions = () => {
    const width = hasWindow ? window.innerWidth : null
    const height = hasWindow ? window.innerHeight : null
    return {
      width,
      height,
    }
  }
  const [messageValue, setMessageValue] = useState({
    text: '',
    file: null,
  })
  const [searchQuery, setSearchQuery] = useState('')
  const [requestedBookings, setRequestedBookings] = useState([])
  const [scheduledBookings, setScheduledBookings] = useState([])
  const [conversations, setConversations] = useState([])
  const [chatMessages, setChatMessages] = useState([])
  useEffect(() => {
    getConversations()
    if (user?.user_type === 'provider') {
      getRequestedBookings()
      getScheduledBookings()
    }
  }, [])

  const getScheduledBookings = async () => {
    setIsLoading(true)
    let result = await getDataById('show-stylist-schedule-booking', {
      stylist_id: user?.id,
    })
    setIsLoading(false)
    if (result?.success === true) {
      if (result?.data) {
        setScheduledBookings(result?.data?.length)
      } else {
        setScheduledBookings(0)
      }
    }
  }

  const getRequestedBookings = async () => {
    setIsLoading(true)
    let result = await getDataById('get-booking-requests', {
      stylist_id: user?.id,
    })
    setIsLoading(false)
    if (result?.success === true) {
      setRequestedBookings(result?.data)
    }
  }

  const messagesSection = useRef()
  const messageImageRef = useRef()

  useEffect(() => {
    const el = document.getElementById('messages-body')
    el?.scrollIntoView({ behavior: 'smooth', block: 'end' })
    if (selectedChat) {
      showMessages()
    }
  }, [selectedChat])

  useEffect(() => {
    const reader = new FileReader()
    reader.addEventListener('load', (event) => {
      messageImageRef.current.src = event.target.result
    })
  }, [messageValue.file])

  useEffect(() => {
    messagesSection.current?.scrollIntoView()
  }, [chatMessages])

  const showMessages = async () => {
    setIsLoading(true)
    let result = await getDataById('show-messages', {
      user_id: user?.id,
      receiver_id: selectedChat?.id,
    })
    setIsLoading(false)
    if (result?.success === true) {
      const messages = result?.data?.map((item, index) => {
        return {
          id: item?.id,
          message: item?.message,
          time: moment(item?.created_at).format('hh:mm a'),
          receiver: item?.receiver_id === user?.id ? 'user' : 'chat_friend',
          image: item?.image ?? '',
        }
      })
      setChatMessages(messages)
    }
  }

  // console.log({ chatMessages })

  const searchConversation = async () => {
    if (searchQuery) {
      let filteredConversations = conversations.filter((item) => {
        if (item.receiver_id === user?.id) {
          if (
            (item?.user?.first_name + ' ' + item?.user?.last_name)
              .toLowerCase()
              .includes(searchQuery.toLowerCase())
          ) {
            return item
          }
        } else {
          if (
            (item?.receiver?.first_name + ' ' + item?.receiver?.last_name)
              .toLowerCase()
              .includes(searchQuery.toLowerCase())
          ) {
            return item
          }
        }
      })
      setConversations(filteredConversations)
    } else {
      getConversations()
    }
  }

  const getConversations = async () => {
    setIsLoading(true)
    let result = await getDataById('show-conversation', { user_id: user?.id })
    setIsLoading(false)
    if (result?.success === true) {
      setConversations(result?.data.reverse())
      let conv = result?.data.reverse()
      if (!location?.state) {
        if (conv[0]?.receiver_id !== user?.id) {
          setSelectedChat(conv[0].receiver)
        } else {
          setSelectedChat(conv[0].user)
        }
      } else if (location?.state) {
        if (location?.state?.booking?.stylist?.id === user?.id) {
          setSelectedChat(location?.state?.booking?.user)
        } else {
          setSelectedChat(location?.state?.booking?.stylist)
        }
      }
    }
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  )
  useEffect(() => {
    if (hasWindow) {
      function handleResize() {
        setWindowDimensions(getWindowDimensions())
      }
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }
  }, [hasWindow])

  useEffect(() => {}, [windowDimensions])

  const handleBookingRequestsModal = () => {
    setToggleBookingRequestsModal(!toggleBookingRequestsModal)
  }
  const handleOpenUserChat = () => {
    setIsResponsive(!isResponsive)
  }

  const handleBackToChats = () => {
    setIsResponsive(!isResponsive)
  }

  const handleSendMessage = async (e) => {
    if (messageValue.text || messageValue.file) {
      setMessageValue((prev) => ({ ...prev, text: '' }))
      let body = {
        user_id: user?.id,
        receiver_id: selectedChat?.id,
        message: messageValue?.text,
      }
      let formData = new FormData()
      formData.append('user_id', user?.id)
      formData.append('receiver_id', selectedChat?.id)
      formData.append('message', messageValue.text)
      if (messageValue.file) {
        body['file'] = messageValue.file
        formData.append('file', messageValue.file)
      }
      setIsLoading(true)
      let result = await saveOrUpdateDataById('send-message', formData)
      setMessageValue({ file: null, text: '' })
      setIsLoading(false)
      if (result?.success === true) {
        const el = document.getElementById('messages-body')
        el?.scrollIntoView({ behavior: 'smooth', block: 'end' })
        showMessages()
      }
    }
  }

  const getUserImage = (con) => {
    if (user?.id === con?.receiver_id) return con?.user?.profile_image
    else return con?.receiver?.profile_image
  }

  return (
    // <div className="container">
    //   <FreshdeskWidget url="https://support.freshdesk.com" formHeight="700px" />
    // </div>
    <div className="chat-screen" style={{ height: 'calc(100vh - 90px)' }}>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100vh',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />

      <div className="container h-100">
        <div className="row h-100 m-0">
          <div
            className={`${
              isResponsive ? 'd-none d-md-block' : 'd-block'
            } col-12 col-sm-12 col-md-6 col-lg-5 users-chats p-0`}
          >
            <div className="chats-container h-100">
              <div className="input-locaiton-wrapper py-2 shadow-none">
                <div className="search-input d-flex align-items-center">
                  <SearchIcon className="search-icon" />
                  <input
                    type="text"
                    className="fs-18 search-text"
                    placeholder="Search"
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        searchConversation()
                      }
                    }}
                  />
                </div>
              </div>
              <h1 className="fs-36 text-center mt-3 fw-bold">Messages</h1>
              <hr className="mt-2" />
              {user?.user_type === 'provider' && (
                <div className="row">
                  <div className="col-6">
                    <div
                      className="booking p-3 pointer"
                      onClick={handleBookingRequestsModal}
                    >
                      <h3 className="text-white fs-18 fw-bold">
                        Booking <br /> Requests
                      </h3>
                      <div className="text-right">
                        <div
                          className="bookings-number d-flex justify-content-center align-items-center p-1 text-white"
                          style={{ marginLeft: 'auto' }}
                        >
                          {requestedBookings?.length}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <Link to={'/styles'} className="text-decoration-none">
                      <div className="booking p-3">
                        <h3 className="text-white fs-18 fw-bold">
                          Confirmed <br /> Bookings
                        </h3>
                        <div className="text-right">
                          <div
                            className="bookings-number d-flex justify-content-center align-items-center p-1 text-white"
                            style={{ marginLeft: 'auto' }}
                          >
                            {scheduledBookings}
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              )}
              <div
                className="chats row mt-3 px-1 gy-3"
                style={{ maxHeight: 'calc(100vh - 212px)', overflow: 'auto' }}
              >
                {conversations &&
                  conversations?.map((con, index) => (
                    <div
                      className="col-12 pointer"
                      key={con.id}
                      onClick={() => {
                        if (con.receiver_id !== user?.id) {
                          setSelectedChat(con.receiver)
                        } else {
                          setSelectedChat(con.user)
                        }
                      }}
                    >
                      <div
                        className="chat d-flex align-items-center justify-content-start"
                        onClick={handleOpenUserChat}
                      >
                        {getUserImage(con) && (
                          <Avatar
                            src={getUserImage(con)}
                            sx={{
                              width: 60,
                              height: 60,
                            }}
                          />
                          // <img
                          //   src={getUserImage(con)}
                          //   alt="Chat User"
                          //   height={70}
                          //   width={90}
                          //   className="p-0"
                          //   style={{ borderRadius: '50%', objectFit: 'cover' }}
                          // />
                        )}
                        {!getUserImage(con) && (
                          <Avatar
                            src={UserPlaceholderImage}
                            sx={{
                              width: 60,
                              height: 60,
                            }}
                          />
                        )}
                        <div className="w-100">
                          <p className="fs-24 font-weight-bold">
                            {con?.receiver_id === user?.id
                              ? con?.user?.first_name +
                                ' ' +
                                con?.user?.last_name
                              : con?.receiver?.first_name +
                                ' ' +
                                con?.receiver?.last_name}
                          </p>
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="fs-15 lh-1 mt-1">{con?.message}</p>
                            <p className="fs-15 opacity-50">
                              {moment(con?.created_at).fromNow()}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div
            className={`${
              isResponsive ? 'd-block' : 'd-none d-md-block'
            } col-sm-12 col-md-6 col-lg-7 chat-messages`}
          >
            {selectedChat && (
              <div className="messages h-100 position-relative">
                <div className="messages-header d-flex align-items-center">
                  <Link
                    to={user?.userType !== 'client' ? '/styles' : '/profile'}
                    className="back-to-styles"
                  >
                    <ChevronLeftIcon
                      sx={{ color: '#01CED1', fontSize: '2.5rem' }}
                    />
                  </Link>
                  <span className="open-chats">
                    <ChevronLeftIcon
                      sx={{ color: '#01CED1', fontSize: '2.5rem' }}
                      onClick={handleBackToChats}
                    />
                  </span>
                  <div className="chat d-flex align-items-center justify-content-start">
                    {selectedChat?.profile_image && (
                      <Avatar
                        src={selectedChat?.profile_image}
                        sx={{ width: 60, height: 60 }}
                      />
                    )}
                    {!selectedChat?.profile_image && (
                      <Avatar
                        src={UserPlaceholderImage}
                        sx={{ width: 60, height: 60 }}
                      />
                    )}
                    <div className="w-100">
                      <p className="fs-24 font-weight-bold">
                        {selectedChat?.first_name +
                          ' ' +
                          selectedChat?.last_name}
                      </p>
                      <p className="fs-18 opacity-50">
                        Last seen {moment(selectedChat?.last_seen).fromNow()}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="messages-body"
                  style={{ height: 'calc(100vh - 200px)', overflow: 'auto' }}
                  id="messages-body"
                >
                  <div className="messages-wrapper pt-5">
                    {chatMessages &&
                      chatMessages?.map((message, index) => (
                        <div
                          className={`${
                            message?.receiver === 'user'
                              ? 'received-message'
                              : 'sent-message text-right'
                          } mt-1`}
                          key={message?.id}
                        >
                          <p
                            className={`${
                              message?.receiver === 'user'
                                ? 'text-white'
                                : 'text-black'
                            } fs-6`}
                            style={{ maxWidth: '75%' }}
                          >
                            {message?.image && (
                              <Avatar
                                src={message.image}
                                sx={{
                                  width: 60,
                                  height: 60,
                                  marginLeft:
                                    message.receiver === 'user' ? '' : 'auto',
                                }}
                              />
                              // <img
                              //   src={message.image}
                              //   alt=""
                              //   style={{
                              //     display: 'block',
                              //     paddingTop: '.5rem',
                              //     borderRadius: '10px',
                              //     height: '150px',
                              //     width: '150px',
                              //     objectFit: 'cover',
                              //     marginLeft:
                              //       message.receiver === 'user' ? '' : 'auto',
                              //   }}
                              // />
                            )}
                            <span
                              style={{
                                paddingRight: '.2rem',
                                wordBreak: 'break-all',
                              }}
                            >
                              {message?.message}
                            </span>
                          </p>
                          <p className="fs-12 opacity-50 message-received-time">
                            {message?.time}
                          </p>
                        </div>
                      ))}
                  </div>
                  <div ref={messagesSection}></div>
                </div>
                <div className="messages-footer pb-2">
                  <label
                    htmlFor="message-attachment"
                    className="pointer position-relative"
                  >
                    <img
                      src={AttachmentIcon}
                      alt=""
                      height={40}
                      className="px-2"
                    />
                    <TextField
                      type="file"
                      name="message-attachment"
                      id="message-attachment"
                      className="d-none"
                      onChange={(e) =>
                        setMessageValue((prev) => ({
                          ...prev,
                          file: e.target.files[0],
                        }))
                      }
                    />
                  </label>
                  {/* <div
                    style={{
                      height: '128px',
                      width: '128px',
                      position: 'absolute',
                      bottom: 0,
                      left: '63px',
                    }}
                  >
                    {messageValue.file && (
                      <img
                        src=""
                        alt=""
                        ref={messageImageRef}
                        width={100}
                        height={100}
                      />
                    )}
                  </div> */}
                  <TextField
                    id="message-input"
                    type="text"
                    name="message-input"
                    placeholder="Write a message"
                    onChange={(e) =>
                      setMessageValue((prev) => ({
                        ...prev,
                        text: e.target.value,
                      }))
                    }
                    value={messageValue?.text}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSendMessage(e)
                      }
                    }}
                    // endAdornment={
                    //   <InputAdornment position="end">
                    //     <img src={SendIcon} alt="Attachment Icon" height={28} />
                    //   </InputAdornment>
                    // }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <img
                            src={SendIcon}
                            alt="Attachment Icon"
                            height={28}
                            className="pointer"
                            onClick={handleSendMessage}
                          />
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <BookingRequestsModal
        handleBookingRequestsModal={handleBookingRequestsModal}
        toggleBookingRequestsModal={toggleBookingRequestsModal}
        requestedBookings={requestedBookings}
        getRequestedBookings={getRequestedBookings}
      />
    </div>
  )
}

export default Chat
